import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Box from '@mui/material/Box';
import colors from '../../../scss/colors';
import classes from './BaseSwipeableDrawer.module.scss';

const BaseSwipeableDrawer = ({
  open = true,
  closeHandler,
  children,
  verticalScroll = 'auto',
  isDivider = true,
  height = 'auto',
  maxHeight = '85vh',
  zIndex = 9999
}) => {
  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onOpen={() => {}}
      onClose={closeHandler}
      disableDiscovery
      sx={{
        '& .MuiModal-root-MuiDrawer-root': {
          zIndex: 1
        },
        '& .MuiPaper-root.MuiDrawer-paper': {
          backgroundColor: 'transparent',
          overflow: 'hidden',
          height,
          maxHeight,
          zIndex
        },
        zIndex
      }}
      data-testid="swipeable-drawer"
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '10px',
          padding: '20px 0 24px 0',
          backgroundColor: colors.PAGE_BACKGROUND,
          borderRadius: '20px 20px 0 0',
          zIndex: 9999,
          maxHeight: 'inherit',
          overflowY: verticalScroll
        }}
      >
        {isDivider && <div className={classes.swiper} />}
        <Box sx={{ width: '100%', overflowY: verticalScroll, WebkitOverflowScrolling: 'touch' }}>{children}</Box>
      </Box>
    </SwipeableDrawer>
  );
};

export default BaseSwipeableDrawer;
